import { Metamodel } from 'app/model/base/model';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { DataFlowExpression } from '../dataflowexpression';
import { DataFlowSink } from '../dataflow-sink';
import { DateDataFlowType, IntegerDataFlowType } from '../dataflow-datatype';
import { CassandraDataset } from 'app/model/dataset/cassandra.dataset';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';
import { DataFlowSource } from '../dataflow-source';
import { TabularTypeSettings } from './tabular-type-settings';

@Metamodel.model({
    name: adfModelTypeMap.cassandra.dataflowSettings
})
export class CassandraSettings extends TabularTypeSettings {
    @Metamodel.attribute({
        display: stringResources.ModelName_KeySpace
    })
    override schemaName: DataFlowExpression;

    public isPreCqlsListOfExpression: boolean;
    public preCqls: DataFlowExpression[];
    public isPostCqlsListOfExpression: boolean;
    public postCqls: DataFlowExpression[];

    @Metamodel.attribute({
        constraint: {
            validator: DataFlowSink.validateTTL
        }
    })
    public ttl: DataFlowExpression;
    public timestamp: DataFlowExpression;

    @Metamodel.attribute({
        constraint: {
            validator: DataFlowSource.validateBatchSize
        }
    })
    public batchSize: DataFlowExpression;

    @Metamodel.attribute({
        constraint: {
            allowed: ['one', 'two', 'three', 'quorum', 'all', 'local_quorum', 'each_quorum', 'local_one']
        }
    })
    public consistencyLevel: string;

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.batchSize = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.isPreCqlsListOfExpression = true;
        this.isPostCqlsListOfExpression = true;
        this.preCqls = [this.transform.createTemplatableExpression()];
        this.postCqls = [this.transform.createTemplatableExpression()];
        this.keyColumns = [this.transform.createTemplatableExpression()];
        this.ttl = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.timestamp = this.transform.createTemplatableExpression(DateDataFlowType.TYPE);
        this.consistencyLevel = 'one';
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Cassandra;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return Metamodel.modelFor(CassandraDataset).name;
    }

    public getIconClass(): string {
        return 'i-100x100-cassandra';
    }
}
